export default class TimelineScrollDragger {
  constructor($timeline, itemsToScroll) {
    this.$scrollBar = $timeline.querySelector('.timeline__scrollbar');
    this.$scrollDragger = this.$scrollBar.querySelector(
      '.timeline__scroll-dragger'
    );
    this.$track = this.$scrollBar.querySelector('.timeline__scroll-track');
    this.itemsToScroll = itemsToScroll;
    this.scrolledIndex = 0;
    this.scrollActive = false;
    this.currentX = 0;
    this.initialX = 0;
    this.offsetX = 0;

    this.init();
  }

  init = () => {
    ['touchstart', 'mousedown'].forEach((event) =>
      this.$scrollDragger.addEventListener(event, this.handleDragStart)
    );
    ['touchend', 'mouseup'].forEach((event) =>
      document.addEventListener(event, this.handleDragEnd)
    );
    ['touchmove', 'mousemove'].forEach((event) =>
      document.addEventListener(event, this.handleDrag, { passive: false })
    );
    this.$track.addEventListener('click', this.handleTrackClick);

    window.addEventListener('resize', this.handleResize);

    this.initInterval();
  };

  initInterval = () => {
    const { width } = this.$track.getBoundingClientRect();
    this.scrollInterval = width / this.itemsToScroll;
    this.scrollMax = width - this.scrollInterval;
    this.scrollIntervals = [];

    for (let i = 0; i < this.itemsToScroll; i += 1) {
      if (i !== this.itemsToScroll - 1) {
        this.scrollIntervals.push(i * this.scrollInterval);
      } else {
        this.scrollIntervals.push(this.scrollMax);
      }
    }

    this.$scrollDragger.style.width = `${this.scrollInterval}px`;
  };

  handleDragStart = (event) => {
    this.$scrollDragger.classList.add('timeline__scroll-dragger--active');

    if (event.type === 'touchstart') {
      this.initialX = event.touches[0].clientX - this.offsetX;
    } else {
      this.initialX = event.clientX - this.offsetX;
    }

    if (event.target === this.$scrollDragger) {
      this.scrollActive = true;
    }
  };

  handleDragEnd = () => {
    this.$scrollDragger.classList.remove('timeline__scroll-dragger--active');
    this.initialX = this.currentX;

    if (this.scrollActive) {
      this.updateScrollDragger(this.currentX);

      // dispatch Event to use the scrolled to index
      this.dragEndEvent = new CustomEvent('scrollDraggerDragEnd', {
        bubbles: true,
        detail: {
          index: this.scrolledIndex,
        },
      });

      this.$scrollDragger.dispatchEvent(this.dragEndEvent);
    }

    this.scrollActive = false;
  };

  handleDrag = (event) => {
    if (this.scrollActive) {
      event.preventDefault();

      if (event.type === 'touchmove') {
        this.currentX = event.touches[0].clientX - this.initialX;
      } else {
        this.currentX = event.clientX - this.initialX;
      }

      if (this.currentX > this.scrollMax) {
        this.currentX = this.scrollMax;
      }

      if (this.currentX < 0) {
        this.currentX = 0;
      }
      this.offsetX = this.currentX;

      // move dragger on track
      this.translateScrollDraggerPosition(this.currentX);

      // dispatch Event to use the scrolled to index
      this.dragEvent = new CustomEvent('scrollDraggerDrag', {
        bubbles: true,
        detail: {
          index: this.getScrolledIndex(),
        },
      });
      this.$scrollDragger.dispatchEvent(this.dragEvent);
    }
  };

  handleTrackClick = (event) => {
    const clickPos =
      event.clientX - (document.body.clientWidth - this.$track.clientWidth) / 2;
    this.currentX = clickPos;
    this.scrollActive = true;
    this.scrolledIndex = this.getScrolledIndex();
    this.handleDragEnd();
  };

  handleResize = () => {
    this.initInterval();
    this.updateScrollDraggerByIndex(0);
  };

  translateScrollDraggerPosition(xPos) {
    this.offsetX = xPos;
    this.$scrollDragger.style.transform = `translateX(${xPos}px)`;
  }

  updateScrollDragger(xPos) {
    const x = this.getClosestIntervalPosition(xPos);
    this.translateScrollDraggerPosition(x);
  }

  updateScrollDraggerByIndex(index) {
    this.updateScrollDragger(index * this.scrollInterval);
  }

  getScrolledIndex() {
    const x = this.getClosestIntervalPosition(this.currentX);
    const index = this.scrollIntervals.indexOf(x);
    this.scrolledIndex = index;
    return index;
  }

  getClosestIntervalPosition(pos) {
    let x = pos;
    if (!this.scrollIntervals.includes(pos)) {
      x = this.scrollIntervals.reduce((prev, curr) =>
        Math.abs(curr - pos) < Math.abs(prev - pos) ? curr : prev
      );
    }
    return x;
  }
}
